import $ from "jquery";
import "slick-carousel";

if ($(".body-type-ctas")) {
  const types = [];

  $(".body-type-ctas")
    .each(function () {
      types.push($(this).data("type"));
    });

  types.forEach((type) => {

    const slider = `body-type-ctas-${type}`

    const $bodyTypeSlider = $(`.${slider}`);

    const $currentSlide = $(`.${type}-controls`).find('.controls__current');


    $bodyTypeSlider.on("init beforeChange", function (event, slick) {
     
      if (slick.$dots) {
        const dots = slick.$dots.find("li");
        const theme = $(`.controls-dots-${type}`).data("theme");
        dots.addClass('slick-dot ' + theme);
      }
      setTimeout(() => {
        $(this).removeClass('bnp-scene');
      }, 1000);
    });

    $bodyTypeSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: true,
      infinite: true,
      appendDots: $(`.controls-dots-${type}`),
      nextArrow: $(`.controls-next-${type}`),
      prevArrow: $(`.controls-prev-${type}`),
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "8%",
          },
        },
      ],
    });

    $bodyTypeSlider.on("setPosition", function (e, slick) {
      slick.$slides.css("height", slick.$slideTrack.height() + "px");
    });
    
    $bodyTypeSlider.on('init reInit beforeChange afterChange', function (event, slick, currentSlide) {
      const current = (currentSlide ? currentSlide : 0) + 1;
      if ($currentSlide) {
        $currentSlide.text(current + '/' + slick.slideCount);
      }
    });

  });
}

